import React from "react";
import { PaperComponent } from "../../utils";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const RelatedTagModal = ({
  isRelTagModalOpen,
  setIsRelTagModalOpen,
  relTagData,
}) => {

  const { t } = useTranslation();


  return (
    <Dialog
      open={isRelTagModalOpen}
      onClose={() => setIsRelTagModalOpen(false)}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      maxWidth="md"
      className="muiForm-Modal"
    >
      <DialogTitle className="model-title mb-0" id="draggable-dialog-title">
        Related Tags
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            paddingTop: "20px",
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            gap: "12px",
          }}
        >
          {relTagData.map((tag, index) => (
            <div
              key={index}
              style={{
                padding: "4px",
                fontSize: "13px",
                textAlign: "center",
              }}
            >
              {tag}
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogActions className="model-actions">
        <button
          className="cnbtn btn cancel-btn"
          variant="outlined"
          onClick={() => setIsRelTagModalOpen(false)}
          color="primary"
        >
          {t("Cancel")}
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default RelatedTagModal;
